import script from "./EditExif.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditExif.vue?vue&type=script&setup=true&lang=ts"

import "./EditExif.vue?vue&type=style&index=0&id=1981e72c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1981e72c"]])

export default __exports__